export const BillingPeriodParentCode = process.env.REACT_APP_BILLING_PERIOD_PARENT_CODE!;

export const SubscriptionStatusEnum = {
  ACTIVE:           "a07546e1e62f641b",
  ABOUT_TO_EXPIRE:  "bcbd01cd3b0fa109",
  EXPIRED:          "540fa0a0ff3b8bc9",
  SUSPENDED:        "87660e24b71689c3",
  CANCELLED:        "a67a78783d7380bc",
} as const;

export type SubscriptionStatusType = 
  (typeof SubscriptionStatusEnum)[keyof typeof SubscriptionStatusEnum];

export const SubscriptionStatusParentCode = "9a94efa8cf56399a";